import styles from './style.module.css';
import Modal from 'react-responsive-modal';

interface IModalHasAnswered {
  modalIsOpen: boolean;
  toggleModal: () => void;
  cancelAnswer: () => void;
}

export function ModalHasAnswered({
  modalIsOpen,
  toggleModal,
  cancelAnswer,
}: IModalHasAnswered) {
  return (
    <Modal
      open={modalIsOpen}
      onClose={() => {
        toggleModal();
        cancelAnswer();
      }}
      center
    >
      <div className={`${styles.modalBanner} ${styles.modalBannerWarning}`}>
        <i className="material-icons-outlined">info</i>
      </div>
      <div className={styles.contents}>
        <h2 className={styles.title}>
          <span className={styles.highlightText}>OPS!</span> Você já respondeu
          esse quiz.
        </h2>
        <p className={styles.detail}>
          Não é possível responder novamente por este link.
        </p>
      </div>
      <div className={styles.contentBtn}>
        <button
          onClick={() => {
            toggleModal();
            cancelAnswer();
          }}
          className={styles.btnAgree}
          type="button"
        >
          Voltar
        </button>
      </div>
    </Modal>
  );
}
